interface SectionHeaderProps {
  title?: string;
  subtitle?: string;
  titleColor?: string;
  subtitleColor?: string;
  titleTag?: 'h2' | 'h3';
}

const formatText = (text: string) => text.replace(/<br>/g, '\n');

export default function SectionHeader({
  title,
  subtitle,
  titleColor,
  subtitleColor,
  titleTag: TitleTag = 'h3',
}: SectionHeaderProps) {
  return (
    <header className="px-[12px] pt-[20px] pb-[12px] text-left">
      {title && (
        <TitleTag
          className="line-clamp-2 whitespace-pre-line font-bb text-[20px] leading-[24px] text-primary-black"
          style={{ color: titleColor || 'var(--color-primary-black)' }}
        >
          {formatText(title)}
        </TitleTag>
      )}
      {subtitle && (
        <h4
          className="mt-[4px] line-clamp-3 whitespace-pre-line font-br text-[12px] font-normal leading-[14px]"
          style={{ color: subtitleColor || '#666666' }}
        >
          {formatText(subtitle)}
        </h4>
      )}
    </header>
  );
}
